import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Menu as BsMenu, MenuItem as BsMenuItem } from 'react-foundation/lib/components/menu';
import { Link } from 'react-router-dom';
import { Icon } from '../../../components/Icon';
import { getEnumById, getUIString } from '../../../utils/helpers';
import { getRoutes } from '../../../utils/routes';
import { allOfferingTypes, getAccountType } from '../../../utils/offeringType';

const StyleMenuWrapper = styled(BsMenu)`
	padding: 0;
	margin: 0;
	list-style-type: none;
`;

const StyledMenuItem = styled(BsMenuItem)`
	& a,
	button {
		display: block;
		width: 100%;
		text-align: left;
		border-bottom: 1px solid #eee;
		padding: 0.6rem;
		cursor: pointer;
		text-decoration: none;
		color: #4c4c4c;
		
		&:hover {
			color: #f00;
		}
	}
`;

// TODO: Mostly same styles in CurrentPage and StyledMenuItem. Should remove duplicate code somehow
const CurrentPage = styled.span`
	display: block;
	width: 100%;
	text-align: left;
	border-bottom: 1px solid #eee;
	padding: 0.6rem;
`;

const IconWrapper = styled.div`
	display: inline-block;
	min-width: 40px;
	text-align: center;
	margin-right: 0.5rem;
`;

const PATH_PREFIX = '/account/';

const StyledIcon = (props) => (
	<IconWrapper>
		<Icon {...props} />
	</IconWrapper>
);

const StyledMenu = (props) => {
	const { children } = props;
	return (
		<StyleMenuWrapper>
			{React.Children.map(children, (child, index) => (
				<StyledMenuItem key={index}>{child}</StyledMenuItem>
			))}
		</StyleMenuWrapper>
	);
};

StyledMenu.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

const createMenuItem = (key, currentPage, toPage, iconName, offeringType) => {
	const styledIcon = <StyledIcon name={iconName} />;
	const menuName = toPage.substring(PATH_PREFIX.length); // We are removing '/account/' to have sensible menuName without using separate parameter
	const menuText = getUIString(getAccountType(offeringType), `Menu.${menuName}`);
	if (currentPage === toPage) {
		return (
			<CurrentPage key={key}>
				{styledIcon}
				{menuText}
			</CurrentPage>
		);
	} else {
		return (
			<Link id={`side-nav-${menuName}`} to={toPage} key={key}>
				{styledIcon}
				{menuText}
			</Link>
		);
	}
};

const Menu = (props) => {
	const currentPage = props.path;
	const customerData = props.customerData;
	const offeringType = getEnumById(customerData.emoSubscriptionType, allOfferingTypes);

	const routes = getRoutes();
	return (
		<StyledMenu>
			{routes.map((route, key) => {
				const icon = route.menuIcon !== undefined ? route.menuIcon(customerData) : undefined;
				if (icon !== undefined) {
					return createMenuItem(key, currentPage, route.path, icon, offeringType);
				} else {
					return null;
				}
			})}
		</StyledMenu>
	);
};

export default Menu;
